import { ErrorTracking } from '../config';

export const safeStringify = (data) => {
  try {
    return JSON.stringify(data);
  } catch (e) {
    ErrorTracking.error('Unable to stringify data (safeStringify)', e, {
      dataType: typeof data,
    });
    return null;
  }
};
